"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestAnswerFeedbackSelectOption = exports.TestAnswerFeedbackDisplayOption = exports.TestAnswerFeedbackType = void 0;
__exportStar(require("./common/types"), exports);
var TestAnswerFeedbackType;
(function (TestAnswerFeedbackType) {
    TestAnswerFeedbackType["validation"] = "validation";
    TestAnswerFeedbackType["info"] = "info";
})(TestAnswerFeedbackType || (exports.TestAnswerFeedbackType = TestAnswerFeedbackType = {}));
var TestAnswerFeedbackDisplayOption;
(function (TestAnswerFeedbackDisplayOption) {
    TestAnswerFeedbackDisplayOption["general"] = "general";
    TestAnswerFeedbackDisplayOption["perOption"] = "perOption";
    TestAnswerFeedbackDisplayOption["combined"] = "combined";
})(TestAnswerFeedbackDisplayOption || (exports.TestAnswerFeedbackDisplayOption = TestAnswerFeedbackDisplayOption = {}));
var TestAnswerFeedbackSelectOption;
(function (TestAnswerFeedbackSelectOption) {
    TestAnswerFeedbackSelectOption["selected"] = "selected";
    TestAnswerFeedbackSelectOption["all"] = "all";
})(TestAnswerFeedbackSelectOption || (exports.TestAnswerFeedbackSelectOption = TestAnswerFeedbackSelectOption = {}));
